import * as React from 'react'
import { SFC } from 'react'

export const BlueGreenBar: SFC<{
    size?: number
    width?: number
    fullWidth?: boolean
    reverse?: boolean
}> = ({size, width, fullWidth, reverse}) => (
    <div
        style={{
            display: 'inline-block',
            height: size || 8,
            margin: 0,
            width: fullWidth ? '100%' : width || 150,
            backgroundImage: !reverse
                ? 'linear-gradient(-90deg, #B4EC51 0%, #53A0FD 47%, #2C3E50 100%)'
                : 'linear-gradient(-90deg, #2C3E50 0%, #53A0FD 47%, #B4EC51 100%)'
        }}
    />
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/BlueGreenBar.tsx